/** 저장이 완료된 노트만 목록/검색 소비자에게 알린다. 입력 중인 초안은 전달하지 않는다. */
const listeners = new Set<(problemId: string) => void>();

export function subscribeToErrorNoteChanges(listener: (problemId: string) => void) {
  listeners.add(listener);
  return () => { listeners.delete(listener); };
}

export function withErrorNoteNotification<Args extends [string, ...unknown[]], Result extends { success: boolean }>(
  action: (...args: Args) => Promise<Result>,
): (...args: Args) => Promise<Result> {
  return async (...args) => {
    const result = await action(...args);
    if (result.success) listeners.forEach((listener) => listener(args[0]));
    return result;
  };
}
